/* eslint-disable camelcase */
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import selectGlobalFields from 'app/selectors/global-fields';
import { parseTime, renderTime12 } from 'app/utilities/time';

const OpeningHours = ({
    btn_primary_label: btnPrimaryLabel,
    btn_primary_link: btnPrimaryLink,
    btn_secondary_label: btnSecondaryLabel,
    btn_secondary_link: btnSecondaryLink,
    bg_image: bgImage,
    globalFields = {}
}) => {
    return (
        <section className="section || opening-hours-block || constrain-width large">
            <div className="inner" style={{ backgroundImage: `url(${bgImage})` }}>
                <div className="opening-hours-container">
                    {globalFields && Object.keys(globalFields).length > 0 && (
                        <div className="opening-hours-content">
                            <h2>Open every day* {renderTime12(parseTime(globalFields.open_time))} - {renderTime12(parseTime(globalFields.close_time))}</h2>
                            <h4>(Last entry at {renderTime12(parseTime(globalFields.last_entry))})</h4>
                            <p className="hide-on-small">*Visit 364 days a year! Closed Christmas Day.</p>
                            <p className="hide-on-large">*Except Christmas Day</p>
                        </div>
                    )}
                    <div className="btn-group">
                        <Link to={btnPrimaryLink} className="button || secondary">{btnPrimaryLabel}</Link>
                        <Link to={btnSecondaryLink} className="button || secondary || hide-on-small">{btnSecondaryLabel}</Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

OpeningHours.propTypes = {
    btn_primary_label: PropTypes.string,
    btn_primary_link: PropTypes.string,
    btn_secondary_label: PropTypes.string,
    btn_secondary_link: PropTypes.string,
    bg_image: PropTypes.string,
    globalFields: PropTypes.object
};

const mapStateToProps = (state) => ({
    globalFields: selectGlobalFields(state)
});

export default connect(mapStateToProps)(OpeningHours);
